export const isFinishAvailableForPaper = (finishingProcess, paperStock) => {
  const minimumWeight = finishingProcess?.minimum_paper_weight_gsm;
  if (minimumWeight == null || minimumWeight === "") return true;

  return Number(paperStock?.weight_gsm) >= Number(minimumWeight);
};

export const isFinishAvailableForJobType = (finishingProcess, jobType) => {
  const availableFor = finishingProcess?.available_for;
  if (!Array.isArray(availableFor) || availableFor.length === 0) return true;

  return availableFor.includes("all") || availableFor.includes(jobType);
};

export const isFinishAvailable = (finishingProcess, paperStock, jobType) =>
  isFinishAvailableForPaper(finishingProcess, paperStock) &&
  isFinishAvailableForJobType(finishingProcess, jobType);
